<template>
  <div class="home-bg">
    <van-nav-bar :title="$route.meta.title" left-arrow fixed @click-left="onClickLeft" />
    <div class="content" :style="{'background-image': 'url(' + url + ')'}"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: ''
    }
  },
  created() {
    this.initFun()
  },
  methods: {
    initFun: function() {
      this.url = this.$route.query.url
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
      //   Toast('返回')
    }
  }
}
</script>

<style scoped lang="scss">
  .home-bg{
    min-height: calc(100vh - 1rem);
    background: white;
  }
  .content{
    height: 7.5rem;
    width: calc(100vh - 55px);
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position-x: 0%;
    background-position-y: 0%;
    transform-origin: 0% 0%;
    transform: rotate(90deg) translateY(-100%);
  }
  /deep/.van-nav-bar .van-icon {
    color: #F18937;
    vertical-align: middle;
  }
</style>
